import { useEffect, useRef } from "react";

const steps = [
  {
    number: "01",
    title: "Wybierz kategorię",
    desc: "Przeglądaj kategorie produktów — od sneakersów po streetwear i akcesoria.",
    icon: "ri-list-check-2",
  },
  {
    number: "02",
    title: "Znajdź produkt",
    desc: "Przeglądaj gotowe linki i znajdź produkt, który Cię interesuje.",
    icon: "ri-search-line",
  },
  {
    number: "03",
    title: "Sprawdź informacje QC",
    desc: "Zobacz zdjęcia kontroli jakości i opinie innych kupujących.",
    icon: "ri-image-line",
  },
  {
    number: "04",
    title: "Przejdź do zakupu",
    desc: "Kliknij link i kup bezpośrednio przez Kakobuy. Szybko i bezpiecznie.",
    icon: "ri-shopping-cart-line",
  },
];

export default function ProcessSection() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
          }
        });
      },
      { threshold: 0.15 }
    );

    const els = sectionRef.current?.querySelectorAll(".reveal-step");
    els?.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="w-full px-4 md:px-8 lg:px-12 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Jak działa Kakobuy Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Cztery proste kroki od znalezienia produktu do zakupu
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {steps.map((step, i) => (
            <div
              key={step.number}
              className="reveal-step opacity-0 translate-y-8 transition-all duration-700 ease-out relative"
              style={{ transitionDelay: `${i * 120}ms` }}
            >
              <div className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/60 h-full">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-3xl md:text-4xl font-heading font-bold text-primary-500/20">
                    {step.number}
                  </span>
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-50 text-primary-600">
                    <i className={`${step.icon} text-lg`} />
                  </div>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950 mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {step.desc}
                </p>
              </div>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-3 w-6 h-px bg-primary-300/40" />
              )}
            </div>
          ))}
        </div>
      </div>

      <style>{`
        .reveal-step.animate-in {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}